import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {LegendConfiguration} from "./legend-configuration";
import {LayerListConfiguration} from "../core/config/layer-list-configuration";
import {PrintConfiguration} from "../core/config/print-configuration";
import {TopicSwitcherConfiguration} from "../core/config/topic-switcher-configuration";

export interface SidebarControlsConfiguration {
    legend: LegendConfiguration;
    layerList: LayerListConfiguration;
    breakpoints: { [key: string]: number };
    print: PrintConfiguration;
    topicSwitcher?: TopicSwitcherConfiguration;
}

@JsonObject()
export class SidebarConfiguration {
    /**
     * Visibility of siedbar
     */
    @JsonProperty()
    declare collapsed: boolean;

    /**
     * Initial width of popup window
     */
    @JsonProperty()
    declare width: number;

    /**
     * The active accordion tab (index)
     *
     * @default ["toc"]
     */
    @JsonProperty()
    declare activeIndex: Array<"basemap_gallery" | "compare" | "legend" | "map_finder" | "print"
    | "sharing" | "toc" | "topic_menu" | "tools" | "tools_sharing" | "layer_selector">;

    /**
     * Exclusive panels open exclusively, all other panels are closed
     */
    @JsonProperty()
    declare exclusivePanels: Array<"basemap_gallery" | "compare" | "legend" | "map_finder" | "print"
    | "sharing" | "toc" | "topic_menu" | "tools" | "tools_sharing" | "np-docs" | "layer_selector">;

    /**
     * Index of disabled panels, which are not displayed.
     */
    @JsonProperty()
    declare enabledPanels: Array<"basemap_gallery" | "compare" | "legend" | "map_finder" | "print"
    | "sharing" | "toc" | "topic_menu" | "tools" | "layer_selector">;

    /**
     * Index of disabled panels, which are not displayed.
     */
    @JsonProperty()
    declare customPanels?: Array<"np-docs">;

    /**
     * Object containing semantic-ui-react icon names to get by key.
     * Use station parameter name as key
     */
    @JsonProperty()
    declare icons: { [stationParameterName: string]: string };

    constructor() {}
}
